const slider = document.querySelector(".slider");
const nestedSlider = document.querySelector(".nested-slider");
const buttonContainer = document.querySelector('.button-container');
const btnTop = buttonContainer.offsetTop;

let currentIndex = 0;
let nestedIndex = 0;
const totalSlides = 3;
const totalNestedSlides = 9;

document.addEventListener('DOMContentLoaded', function() {
    const introHeight = document.querySelector('.fun-fact').offsetHeight;
    const introX = document.querySelector('.fun-fact').offsetTop;
    const newHeight = introHeight + introX + 120;

    document.querySelector('.online__quiz').style.height = newHeight + 'px';
    console.log(newHeight);
});


function slideTo(index) {
	currentIndex = index;
	const offset = -currentIndex * 100;
	slider.style.transform = `translateX(${offset}%)`;

    if(currentIndex === 1){
        adjustButtonContainerMargin(0);
    }
}

function nestedSlideTo(index) {
	nestedIndex = index;
	const offset = -nestedIndex * 100;
	const prevBtn = document.getElementById("prev__btn");
	
	nestedSlider.style.transform = `translateX(${offset}%)`;
	updateCurrentSlideIndex();
	if (nestedIndex === totalNestedSlides - 1) {
		// Run your function when it's the last slide
		lastSlideFunction();
	} else if (nestedIndex > 0) {
		prevBtn.classList.remove("hidden");
        if(checkCurrentSlideAnswers()){
            toggleDisabled("on", "next__btn");
        }else{
            toggleDisabled("off", "next__btn");
        }
	} else {
		prevBtn.classList.add("hidden");
	}

    adjustButtonContainerMargin(index);
}

function prevSlide() {
	currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
	slideTo(currentIndex);
}

function nextSlide() {
	currentIndex = (currentIndex + 1) % totalSlides;
	slideTo(currentIndex);
}

function nestedPrevSlide() {
	nestedIndex = (nestedIndex - 1 + totalNestedSlides) % totalNestedSlides;
	nestedSlideTo(nestedIndex); 
    //console.log('nested index: '+ nestedIndex+' --- TS-2: '+(totalNestedSlides - 2));
    if(nestedIndex === totalNestedSlides - 2){
        lastSlideFunction();
    }else if(nestedIndex === 0){
        checkInput();
    }
}

function nestedNextSlide() {
	nestedIndex = (nestedIndex + 1) % totalNestedSlides;
	nestedSlideTo(nestedIndex);
}

function updateCurrentSlideIndex() {
	const currentSlideIndexElement = document.getElementById("currentSlideIndex");
	currentSlideIndexElement.textContent = nestedIndex + 1; // Display index starting from 1
	updateProgressBar();
}

function updateProgressBar() {
	const pbar = document.getElementById("progress__bar");
	const progress = nestedIndex / totalNestedSlides;
	pbar.style.width = progress * 100 + "%";
}

function lastSlideFunction() {
	 // Replace with your desired action
	// You can do something specific when it's the last slide
	const element1 = document.querySelector(".go-next:not(.hidden)");
	const element2 = document.querySelector(".go-next.hidden");

	element1.classList.add("hidden");
	element2.classList.remove("hidden");

	toggleDisabled("off", "get__results");
}

// Run this function before moving to the next slide to ensure they have answered the question.
function checkAnswers() {
	const prevButton = document.querySelector(".go-prev");
	//console.log("checking answers");

	return true;
}

// Adjust the position of the buttons on slides that are shorter
function adjustButtonContainerMargin(nindex) {
    buttonContainer.style.marginTop = '0px';
    const currentSlide = slider.querySelector('.question:nth-child(' + (nindex + 1) + ')');
    const currentQuestion = currentSlide.querySelector('.question-wrap');
	
    const slideHeight = currentQuestion.offsetHeight;
    const newMargin = btnTop - (currentQuestion.offsetHeight + currentQuestion.offsetTop + 90);
    // console.log('Question Height: ' + (slideHeight + currentQuestion.offsetTop));
    // console.log('Buttons Top: ' + btnTop);
    // console.log('New Margin: ' + newMargin);
	
    if (slideHeight < btnTop){
        buttonContainer.style.marginTop = `-${newMargin}px`;
    }
	
  }

// Check if an answer has been selected within the visible slide
function checkCurrentSlideAnswers() {
    const currentSlide = slider.querySelector('.question:nth-child(' + (nestedIndex + 1) + ')');
    const visibleAnswers = currentSlide.querySelectorAll('.answer');
    
    let isAnswerSelected = false;
    visibleAnswers.forEach(answer => {
      if (answer.classList.contains('selected')) {
        isAnswerSelected = true;
      }
    });

    if (!isAnswerSelected) {
        //console.log('NO answer selected on ' + nestedIndex);
        return false;
    } else {
        // Proceed to the next step for this slide
        //console.log('Answers were selected on ' + nestedIndex);
        return true;
    }
  }

// Check input on the first slide
function checkInput() {
	const inputElement = document.getElementById("cus_name");
	const inputValue = inputElement.value.trim(); // Remove leading/trailing whitespace
	const validationMessageElement = document.getElementById("validation_message");

	if (inputValue.length >= 2) {
		validationMessageElement.textContent = ""; // Clear validation message
		toggleDisabled("on", "next__btn");
	} else {
		validationMessageElement.textContent = "Please enter at least 2 letters";
		toggleDisabled("off", "next__btn");
	}
}

// Function to turn on and off the next button if the question has not been answered
function toggleDisabled(setOn, btn) {
	const button = document.getElementById(btn);
	if (setOn == "off") {
		button.setAttribute("disabled", "true");
	} else {
		button.removeAttribute("disabled");
	}
}

// Function to listen for answer selection and remove selected class from all others.
const answerElements = document.querySelectorAll(".answer");
const nextBtn = document.getElementById("next__btn");

answerElements.forEach(answerElement => {
    answerElement.addEventListener('click', () => {
      const answerContainer = answerElement.closest('.answers');
      const otherAnswerElements = answerContainer.querySelectorAll('.answer');

      if (answerContainer.classList.contains('multiple-answers')) {
        // Do nothing
      }else{
        // deselect all selected answers
        otherAnswerElements.forEach(otherElement => {
            if (otherElement !== answerElement) {
            otherElement.classList.remove('selected');
            }
        });
      }
      answerElement.classList.add('selected');
      toggleDisabled("on", "next__btn");
	  toggleDisabled("on", "get__results");
    });
  });

// Reset all answers
function resetSelectedAnswers() {
	const selectedAnswers = document.querySelectorAll(".answer.selected");

	selectedAnswers.forEach((answer) => {
		answer.classList.remove("selected");
	});
}

function clearInput() {
	const inputElement = document.getElementById("cus_name");
	inputElement.value = ""; // Set the value to an empty string
}

// Reset the online quiz
function resetSlider() {
	slideTo(0); // Go back to the first slide
	nestedSlideTo(0); // Go back to first question
	resetSelectedAnswers(); // Reset the answers
	lastSlideFunction();
	//clearInput();
	toggleDisabled("off", "next__btn"); // Reset next button
	const element2 = document.getElementById("prev__btn");
	element2.classList.add("hidden");
}


var totalAnswers = 0;


function updateReport(repid,showme,status){
	var repId = document.getElementById(`${repid}`);
	var showMe = repId.querySelectorAll(`.${showme}`);
	var staTus = repId.querySelectorAll('.rating');

	// Loop through all the elements with class showme and remove the hidden class
	showMe[0].classList.remove('hidden');
	staTus[0].classList.add(`${status}`);

	//console.log(repid,showme,status);

	if(status === 'uhoh'){
		staTus[0].innerHTML = 'Attention';
		totalAnswers = totalAnswers + 2;
	}else if(status === 'bad'){
		staTus[0].innerHTML = 'Requires Attention';
		totalAnswers = totalAnswers + 3;
	}else if(status === 'okay'){
		staTus[0].innerHTML = 'Average / Good';
		totalAnswers = totalAnswers + 1;
	}else if(status === 'good'){
		staTus[0].innerHTML = 'Excellent';
	}

}

function getTotals(){
	//console.log(totalAnswers);
	var graded = document.querySelector('.grade');
	var gradeTxt = document.querySelector('.score-c');
	var gradeColor = document.getElementById("res_score");
    var resTxt = document.getElementById("results_text");
	if(totalAnswers < 3){
		graded.textContent ='A+';
		gradeTxt.textContent ='Excellent';
		gradeColor.classList.add('great');
        resTxt.innerHTML = 'Wow, you did a great job on your colon health assessment online! You scored 90%, which means you have a very low risk of developing colon cancer or other diseases. That\'s something to be proud of and celebrate!';
        var lowDose = document.querySelector(".low-dose");
        lowDose.classList.remove('hidden');
	}else if(totalAnswers < 9){
		graded.textContent ='B-';
		gradeTxt.textContent ='Good';
		gradeColor.classList.add('good');
        resTxt.innerHTML = 'Congratulations, you scored 80% on your colon health assessment online! You have a low risk of developing colon cancer or other diseases. That\’s a great achievement and a reason to smile! Maintaining colon health is vital, see your recommendation below!';
        var lowDose = document.querySelector(".low-dose");
        lowDose.classList.remove('hidden');
	}else if(totalAnswers < 17){
		graded.textContent ='C-';
		gradeTxt.textContent ='Average';
		gradeColor.classList.add('okay');
        resTxt.innerHTML = 'You scored 60% on your colon health assessment online. You have a moderate risk of developing colon cancer or other diseases. That’s not bad, but you can do better! 😊<br><br>You have some room for improvement in taking care of your colon by eating less red meat, avoiding processed foods, quitting smoking, and increasing physical activity. Be consistent colon cancer screenings according to your age and family history. You can reduce your risk of colon cancer by reading our recommendation below and making simple changes in your lifestyle and habits.';
        var avgDose = document.querySelector(".avg-dose");
        avgDose.classList.remove('hidden');
	}else if(totalAnswers < 27){
		graded.textContent ='D';
		gradeTxt.textContent ='Poor';
		gradeColor.classList.add('poor');
        resTxt.innerHTML = 'You scored 40% on your colon health assessment online. You have a high risk of developing colon cancer or other diseases. That\’s not good, but you can change that! 😊<br><br>You need to take urgent action to take care of your colon by eating more fiber, drinking more water, losing weight, and reducing stress. You also need to get screened for colon cancer as soon as possible, especially if you have any symptoms or a family history of the disease. You can prevent or treat colon cancer by detecting it early and following your doctor\’s advice.';
        var uhohDose = document.querySelector(".uhoh-dose");
        uhohDose.classList.remove('hidden');
	}else if(totalAnswers >= 33){
		graded.textContent ='F';
		gradeTxt.textContent ='Very Poor';
		gradeColor.classList.add('fail');
        resTxt.innerHTML = 'You scored 20% on your colon health assessment online. You have a very high risk of developing colon cancer or other diseases. That\’s alarming, but you can still do something about it! 😊<br><br>You need to take immediate action to take care of your colon by eating less fat, sugar, and salt, drinking less alcohol and caffeine, quitting smoking, and managing stress. You also need to get screened for colon cancer as soon as possible, especially if you have any symptoms or a family history of the disease. You can prevent or treat colon cancer by detecting it early and following your doctor\’s advice.';
        var poorDose = document.querySelector(".poor-dose");
        poorDose.classList.remove('hidden');
	}
}

function jumpTo(){
    document.querySelector('#recommendation').scrollIntoView({ behavior: 'smooth' });
}
function calculateResults(){
	// Set the initial value to 0
	const totalPoints = 0;
	// Get the value of the input with id cus_name
	// var cus_name = document.getElementById("cus_name").value;
	// var customer_names = document.getElementsByClassName("cname");
	// for (var i = 0; i < customer_names.length; i++) {
	// 	customer_names[i].innerHTML = cus_name;
	// }
	// --------------------------------------------------------------
	// QUESTION 1 ---------------------------------------------------
	var answers_2 = document.getElementById("answers_2");
	var selected_answer = answers_2.querySelectorAll(".answer.selected");
	var data_cnt = selected_answer[0].getAttribute("data-cnt");
		// Do something with data_cnt, such as console.log or alert
	//console.log('Answer 1 ' + data_cnt);
	if(parseInt(data_cnt) === 1){
		updateReport('report__energy','normal','okay');
	}else if(parseInt(data_cnt) === 2){
		updateReport('report__energy','recommendation','uhoh');
	}else if(parseInt(data_cnt) === 3){
		updateReport('report__energy','attention','bad');
	}else{
		updateReport('report__energy','info','good');
	}



	// --------------------------------------------------------------
	// QUESTION 2 ---------------------------------------------------
	var answers_4 = document.getElementById("answers_4");
	var selected_answer = answers_4.querySelectorAll(".answer.selected");
	var data_cnt = selected_answer[0].getAttribute("data-cnt");
		// Do something with data_cnt, such as console.log or alert
	//console.log('Answer 2 ' + data_cnt);
	if(parseInt(data_cnt) === 1){
		updateReport('report__stool','recommendation','uhoh');
	}else if(parseInt(data_cnt) === 2){
		updateReport('report__stool','pebbles','bad');
	}else if(parseInt(data_cnt) === 3){
		updateReport('report__stool','hard-stool','bad');
	}else if(parseInt(data_cnt === 6)){
		updateReport('report__stool','danger','bad');
		totalAnswers = totalAnswers + 3;
	}else{
		updateReport('report__stool','goodjob','good');
	}





	// --------------------------------------------------------------
	// QUESTION 3 ---------------------------------------------------
	var answers_5 = document.getElementById("answers_5");
	var selected_answer = answers_5.querySelectorAll(".answer.selected");
	var data_cnt = selected_answer[0].getAttribute("data-cnt");
		// Do something with data_cnt, such as console.log or alert
	//console.log('Answer 3 ' + data_cnt);
	if(parseInt(data_cnt) === 4){
		updateReport('report__digest','night','okay');
	}else if(parseInt(data_cnt) === 2){
		updateReport('report__digest','meals','uhoh');
	}else if(parseInt(data_cnt) === 1){
		updateReport('report__digest','mornings','okay');
	}else if(parseInt(data_cnt === 3)){
		updateReport('report__digest','all','bad');
	}else{
		updateReport('report__digest','info','good');
	}



	// --------------------------------------------------------------
	// QUESTION 4 ---------------------------------------------------
	var answers_8 = document.getElementById("answers_8");
	var selected_answer = answers_8.querySelectorAll(".answer.selected");
	var data_cnt = selected_answer[0].getAttribute("data-cnt");
		// Do something with data_cnt, such as console.log or alert
	//console.log('Answer 4 ' + data_cnt);
	if(parseInt(data_cnt) === 3){
		updateReport('report__acne','oily','okay');
	}else if(parseInt(data_cnt) === 2){
		updateReport('report__acne','acne','uhoh');
	}else if(parseInt(data_cnt) === 1){
		updateReport('report__acne','flaky','okay');
	}else{
		updateReport('report__acne','info','good');
	}



	// --------------------------------------------------------------
	// QUESTION 5 ---------------------------------------------------
	var answers_9 = document.getElementById("answers_9");
	var selected_answer = answers_9.querySelectorAll(".answer.selected");
	var data_cnt = selected_answer[0].getAttribute("data-cnt");
		// Do something with data_cnt, such as console.log or alert
	//console.log('Answer 5 ' + data_cnt);
	if(parseInt(data_cnt) === 1){
		updateReport('report__mood','anger','uhoh');
	}else if(parseInt(data_cnt) === 2){
		updateReport('report__mood','moods','bad');
	}else{
		updateReport('report__mood','info','good');
	}


    //--------------------------------------------
    //----------- Summing all the questions that
    //----------- were not addressed above 
    //--------------------------------------------
    var answers_3 = document.getElementById("answers_3");
    var answers_6 = document.getElementById("answers_6");
    var answers_7 = document.getElementById("answers_7");
    var selected_answer3 = answers_3.querySelectorAll(".answer.selected");
    var selected_answer6 = answers_6.querySelectorAll(".answer.selected");
    var selected_answer7 = answers_7.querySelectorAll(".answer.selected");
    var data_cnt3 = selected_answer3[0].getAttribute("data-cnt");
    var data_cnt6 = selected_answer6[0].getAttribute("data-cnt");
    var data_cnt7 = selected_answer7[0].getAttribute("data-cnt");

    totalAnswers = totalAnswers + parseInt(data_cnt3) + parseInt(data_cnt6) + parseInt(data_cnt7);


	getTotals();
	slideTo(2);

}